/**
 * TanStack Query hooks for `campaign-fallback`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	campaignFallbackQueryKeys,
	type CreateCampaignFallbackBody,
	type ListCampaignFallbackResponse,
	type CampaignFallbackRow,
} from "./api";

export function useCampaignFallbackList(): UseQueryResult<ListCampaignFallbackResponse, Error> {
	return useQuery({
		queryKey: campaignFallbackQueryKeys.list(),
		queryFn: list,
	});
}

export function useCampaignFallbackCreate(): UseMutationResult<CampaignFallbackRow, Error, CreateCampaignFallbackBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: campaignFallbackQueryKeys.all });
		},
	});
}

export function useCampaignFallbackDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: campaignFallbackQueryKeys.all });
		},
	});
}
